module.exports = __webpack_public_path__ + "img/首创置业.22ca6f7f.png";